import React from "react";
import Zoom from "react-reveal/Zoom";
//images
import money from "../../../../../assets/images/redesign/signup-react/money.png";
import headphones from "../../../../../assets/images/redesign/signup-react/Bitmap.png";
import cleaner from "../../../../../assets/images/redesign/signup-react/cleaner.png";
import redoval from "../../../../../assets/images/redesign/signup-react/red-oval.png";
import coffe from "../../../../../assets/images/redesign/signup-react/coffe.png";
import cleanerSecond from "../../../../../assets/images/redesign/signup-react/cleaner-second.png";
import purpurleoval from "../../../../../assets/images/redesign/signup-react/purpurle-oval.png";
import blueoval from "../../../../../assets/images/redesign/signup-react/blue-oval.png";
import amazon from "../../../../../assets/images/redesign/signup-react/amazon.png";
import yellowOval from "../../../../../assets/images/redesign/signup-react/yellow-oval.png";
import sephora from "../../../../../assets/images/redesign/signup-react/sephora.png";
import watch from "../../../../../assets/images/redesign/signup-react/watch.png";
import sephoraSecond from "../../../../../assets/images/redesign/signup-react/sephore-second.png";

function HeroImages() {
  return (
    <div className="pw-hero-container--secondary">
      <div className="pw-container">
        <h1 className="pw-hero-container--second-title">
          The best things in life are free!
        </h1>

        <div className="pw-hero-container--second-image-container">
          <Zoom>
            <div className="pw-money-img-container">
              <img src={money} alt="" />
            </div>
          </Zoom>

          <Zoom>
            <div className="pw-headphones-img-container">
              <img src={headphones} alt="" />
            </div>
          </Zoom>

          <Zoom>
            <img className="pw-cleaner-img" src={cleaner} alt="" />
          </Zoom>

          <Zoom>
            <img className="pw-red-oval-img" src={redoval} alt="" />
          </Zoom>
          <Zoom>
            <img className="pw-coffee-img" src={coffe} alt="" />
          </Zoom>
          <Zoom>
            <img className="pw-cleaner-second-img" src={cleanerSecond} alt="" />
          </Zoom>
          <Zoom>
            <img className="pw-purple-oval-img" src={purpurleoval} alt="" />
          </Zoom>
          <Zoom>
            <img className="pw-blue-oval-img" src={blueoval} alt="" />
          </Zoom>
          <Zoom>
            <img className="pw-amazon-img" src={amazon} alt="" />
          </Zoom>
          <Zoom>
            <img className="pw-yellow-oval-img" src={yellowOval} alt="" />
          </Zoom>
          <Zoom>
            <div className="pw-sephora-img-container">
              <img src={sephora} alt="" />
            </div>
          </Zoom>

          <Zoom>
            <div className="pw-watch-img-container">
              <img src={watch} alt="" />
            </div>
          </Zoom>

          <Zoom>
            <div className="pw-sephora-second-img-container">
              <img src={sephoraSecond} alt="" />
            </div>
          </Zoom>
        </div>
      </div>
    </div>
  );
}

export default HeroImages;
